<template>
  <div class="lh-homes imgs" style="background-image:url(img/bg.png)">
  	<div style="display:none;">
  		<img src="img/bg.png" />
  		<img src="img/figure.png" />
  		<img src="img/figure2.png" />
  	</div>
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：{{logoText}}</span></div>
    <ul class="lh-injury-item clearfix">
    	<li v-for="(item,idx) in datas" :data-idx="idx" :class="[item.hover,item.end]" @click="item.hover?next($event):''">
    		<div class="icon"><img :src="item.img" /></div>
    		<div class="jt"><img src="img/jt.png"></div>
    	</li>
    </ul>
    <div class="lh-injury-layer imgs" style="background-image:url(img/a5.png)">
    	<a href="javascript:;" class="lh-layer-close" @click="closeLayer($event)"><img src="img/close.png" /></a>
    	<div class="lh-kayer-cont">
    		<h3 class="title">{{datas[datasIdx].title}}</h3>
    		<div class="ccont" v-html="datas[datasIdx].ccont"></div>
    	</div>
    </div>
    <div class="lh-renwu">
    	<div class="icon" :style="'background-image:url('+renwu+')'"></div>
    </div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:1,type:'culture'},
			logoText:'工伤——工伤认定',
			datasIdx:0,
			renwu:'img/figure.png',
			renwus:['img/a6.png','img/a7.png','img/a8.png'],
			webs:false,
			datas:[
				{img:'img/a1.png',hover:'on',end:'',x:'31vw',web:'30vh',class:'renwuBox1',duration:1.4,title:'职工有下列情形之一的，应当认定为工伤：',ccont:'1.在工作时间和工作场所内，因工作原因受到事故伤害的<br />2.工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作受到事故伤害的<br />3.在工作时间和工作场所内，因履行工作职责受到暴力等意外伤害的<br />4.患职业病的<br />5.因工外出期间，由于工作原因受到伤害或者发生事故下落不明的<br />6.在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的<br />7.法律、行政法规规定应当认定为工伤的其他情形'},
				{img:'img/a2.png',hover:'',end:'',x:'48vw',web:'48vh',class:'renwuBox2',duration:1.4,title:'职工有下列情形之一的，视同工伤：',ccont:'1.在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡的<br />2.在抢险救灾等维护国家利益、公共利益活动中受到伤害的<br />3.职工原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到用人单位后旧伤复发的'},
				{img:'img/a3.png',hover:'',end:'',x:'65vw',web:'67vh',class:'renwuBox3',duration:1.4,title:'职工符合本条例第十四条、第十五条的规定，但是有下列情形之一的，不得认定为工伤或者视同工伤：',ccont:'1.故意犯罪的<br />2.醉酒或者吸毒的<br />3.自残或者自杀的'},
				{img:'img/a4.png',hover:'',end:'',x:'82vw',web:'86vh',class:'renwuBox4',duration:1.4}
			]
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
      if($('body').width()<=980){
      	that.webs=true;
      }
    },
	components:{
		Footer
	},
	methods:{
		next(e){
			var that=this,tag = $(e.currentTarget),idx=$(e.currentTarget).data('idx');
			that.datas[idx].hover="";
			that.datas[idx].end="end";
			$('.lh-renwu .icon').css({'animation-play-state':'running'});
			$('.lh-renwu').css({transform:'translate('+(that.webs?that.datas[idx].web:that.datas[idx].x)+',0)',transition:'linear '+that.datas[idx].duration+'s'});
			var length=that.renwus.length,num=0;
			setTimeout(function(){
				that.renwu='img/figure2.png';
				$('.lh-renwu .icon').css({'animation-play-state':'running'});
				$('.lh-renwu').addClass(that.datas[idx].class);
				setTimeout(function(){
					that.renwu='img/figure.png';
					$('.lh-renwu').removeClass(that.datas[idx].class);
					$('.lh-renwu .icon').css({'animation-play-state':'paused'});
					if(!that.datas[idx].title){
						that.$router.replace({ path: 'case'});
					}
					$('.lh-homes').addClass('Layer');
				},450);
			},that.datas[idx].duration*1000);
		},
		closeLayer(e){
			var that=this;
			$('.lh-homes').removeClass('Layer');
			that.datasIdx+=1;
			that.datas[that.datasIdx].hover="on";
		},
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		},
	}
}
</script>
